import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "../context/UserContext";

const GuestRoute = ({ children }) => {
  const { user } = useContext(UserContext);

  return user ? <Navigate to="/" replace /> : children;
};

export default GuestRoute;
